<template>
  <div class="featured">
    <div class="page"/>
    <main class="main main__home" role="main">
      <section id="about" class="section">
        <div class="page">
          <h2>{{ $t('navigation.privacyPolicyAndTerms') }}</h2>
          <div v-html="privacyContent"/>
          <a href="mailto:fiesta@plop.com.ar" class="bt">Contactar</a>
        </div>
      </section>
    </main>
  </div>
</template>

<script setup lang="ts">
import api from "~/api";
import {onMounted} from "vue";

definePageMeta({layout: 'base-layout',});
const privacyContent = ref('');
onMounted(async () => {
  const privacy = await api.TermsAndConditions.getTermAndConditionByLanguage('es');
  privacyContent.value = privacy.data.content;
})

</script>